<template>
  <ul class="sidebar-nav lms-nav">
    <li class="nav-item">
      <router-link
        :to="{ name: 'lmsDashboard' }"
        class="nav-link"
        :class="{ active: $route.name == 'lmsDashboard' }"
      >
        <feather type="home"></feather>Эхлэл
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="{ name: 'lmsActivity' }"
        class="nav-link"
        :class="{ active: $route.name == 'lmsActivity' }"
      >
        <feather type="activity"></feather>Хяналтын самбар
      </router-link>
    </li>
    <li class="nav-item">
      <router-link to="/lms/admin/115/0/0" class="nav-link">
        <feather type="award"></feather>Миний сургалтууд
      </router-link>
    </li>
    <li class="nav-item">
      <router-link to="/lms/admin/115/1/0" class="nav-link">
        <feather type="plus-square"></feather>Сургалт үүсгэх
      </router-link>
    </li>
    <li class="nav-item show">
      <a class="nav-link"> <feather type="plus-circle"></feather>Форм </a>
      <nav class="nav">
        <router-link to="/form/listsurvey/700/1/0" class="">
          Судалгаа үүсгэх</router-link
        >
        <router-link to="/form/listtest/800/1/0" class="">
          Тестийн сан үүсгэх</router-link
        >
        <router-link to="/form/listlesson/500/1/0" class="">
          Явцын шалгалт үүсгэх</router-link
        >
        <router-link to="/form/listexam/900/1/0" class="">
          Сургалтын шалгалт үүсгэх</router-link
        >
      </nav>
    </li>
    <li class="nav-item">
      <router-link to="/report/list/451/0/0" class="nav-link">
        <feather type="layers"></feather>Тайлан
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="{ name: 'lmsCalendarTeacher' }"
        class="nav-link"
        :class="{ active: $route.name == 'lmsCalendarTeacher' }"
      >
        <feather type="calendar"></feather>Календар
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    counts: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    // navopen(name) {
    //     if(name=='lmsCourses'){
    //       this.$router.push({
    //         name: 'lmsCourses',
    //         params:{
    //           md: 1,
    //           cnm: 'null',
    //           type:-1,
    //           d1: 'null',
    //           d2: 'null',
    //         }
    //       });
    //     }
    //     else if(this.$route.name!=name){
    //         this.$emit("route-changed");
    //         this.$router.push({ name: name });
    //     }
    // },
    // subNavOpen(id){
    //     this.$emit("sub-nav-change", id);
    // },
  }
};
</script>

<style></style>
